<template>
  <div>

  </div>
</template>

<script>
export default {
  name: "sidbarItem",
  props: {
    item: {
      type: Object,
    }
  },
  data() {
    return {

    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Education/sidbarItem.vue